/** Human labels for the platforms that surface as trending movers / social tiles (mirrors DashboardAnalytics). */
export const PLATFORM_LABELS: Record<string, string> = {
  spotify: "Spotify",
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  youtube: "YouTube",
  threads: "Threads",
  apple: "Apple Music",
  amazon: "Amazon Music",
};

export const platformLabel = (p: string | null | undefined): string =>
  p ? (PLATFORM_LABELS[p] ?? p) : "—";

/**
 * Zoneless domain date: parse a bare `YYYY-MM-DD` at LOCAL NOON, never as UTC.
 *
 * `new Date("2026-08-19")` is treated as UTC midnight, which renders as the previous day for anyone west of
 * Greenwich — a release dated the 19th showing as the 18th. Noon is far enough from both midnights that no
 * timezone can shift the calendar day. Shared here because the rule was being restated as a comment and
 * re-implemented as a literal at each call site.
 */
export const parseDomainDate = (iso: string) => new Date(`${iso}T12:00:00`);
